
const state = [
	{ 
		id: 	"RoHvoiRymMd4N2B", 
		name: 	"Stadtlandfluss Klinikum GmbH"
	},
]


const actions = {} 

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
